<div class="banner-header d-md-flex d-none"
    [ngStyle]="{'background-image' : 'url('+ apiAsset + dataBanner?.picture +')'}">
    <h1 class="mb-0 text-center" [ngClass]="fontSize">{{ dataBanner?.title }}</h1>
</div>
<div class="banner-header-m pb-4 d-md-none d-flex">
    <h1 class="text-center" [ngClass]="fontSize">{{ dataBanner?.title }}</h1>
</div>
